import { useMemo, useState } from 'react';
import { List, TextField, useTranslate } from 'react-admin';
import { CustomDatagrid, CrudListActions, RowActionsMenu } from '@/components/common';
import { compactListSx } from '@/components/common/compactListSx';
import {
  CollapsibleFilterPanel,
  FilterExpandContext,
} from '@/components/common/CollapsibleFilterPanel';
import { CustomTextInputFilter } from '@/components/common/CustomFilters';

// Staff <-> schedule mapping list. The list endpoint flattens the included relations,
// so the staff / schedule / organization names arrive as dotted source paths.
export const StaffScheduleList = () => {
  const translate = useTranslate();
  const [filtersExpanded, setFiltersExpanded] = useState(false);
  const filterExpandValue = useMemo(
    () => ({ expanded: filtersExpanded, setExpanded: setFiltersExpanded }),
    [filtersExpanded]
  );

  const filters = useMemo(
    () => [
      <CollapsibleFilterPanel key="filters" source="_cfp" alwaysOn alwaysVisibleCount={0}>
        <CustomTextInputFilter
          source="q"
          label={translate('common.filters.search', { _: 'Buscar' })}
          alwaysOn
        />
      </CollapsibleFilterPanel>,
    ],
    [translate]
  );

  return (
    <FilterExpandContext.Provider value={filterExpandValue}>
      <List
        sx={compactListSx}
        filters={filters}
        actions={
          <CrudListActions
            exportColumns={['staff.full_name', 'department.name', 'organization.full_name']}
          />
        }
        sort={{ field: 'user_group_organization_id', order: 'DESC' }}
        exporter={false}
      >
        <CustomDatagrid
          primarySource="staff.full_name"
          secondarySource="department.name"
          bulkActionButtons={false}
        >
          <RowActionsMenu label="" sortable={false} />
          <TextField source="staff.full_name" sortable={false} />
          <TextField source="department.name" sortable={false} />
          <TextField source="organization.full_name" sortable={false} />
        </CustomDatagrid>
      </List>
    </FilterExpandContext.Provider>
  );
};

export default StaffScheduleList;
